<ng-container *transloco="let t">
<div class="post d-flex flex-column-fluid mt-8">
  <div class="container">
    <div class="card">
      <div class="card-body p-0">
        <div class="card-px text-center py-20 my-10">
          <h2 class="fs-2x fw-bolder mb-10">{{ heading || t('common.loading.welcome') }}</h2>
          <p class="text-gray-400 fs-4 fw-bold mb-4">{{ message1 || t('common.loading.startingApplication') }}</p>
          <p class="text-gray-400 fs-4 fw-bold mb-10">{{ message2 || t('common.loading.preparingApplication') }}</p>
          <div class="loda-spinner" role="status" aria-live="polite">
            <svg viewBox="0 0 50 50" aria-hidden="true">
              <circle class="loda-spinner__track" cx="25" cy="25" r="20"></circle>
              <circle class="loda-spinner__arc" cx="25" cy="25" r="20"></circle>
            </svg>
          </div>
        </div>
        @if (showImage) {
          <div class="text-center px-4">
            <img class="mw-100 mh-300px" alt="" src="assets/media/illustrations/terms-1.png" />
          </div>
        }
      </div>
    </div>
  </div>
</div>
</ng-container>
